import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PublicRoute() {
  const user = useSelector((state) => state.auth.user);

  if (user) {
    const role = user.role?.toUpperCase();

    if (role === "ADMIN") {
      return <Navigate to="/admin" replace />;
    }

    if (role === "OFFICER") {
      return <Navigate to="/officer-app" replace />;
    }
  }

  return <Outlet />;
}